import React from 'react';
import { Beaker, Users, List, Target, TrendingUp, Settings } from 'lucide-react';

const sidebarItems = [
  { title: "Experiments", icon: Beaker, key: "experiments", href: "/" },
  { title: "ICP Ideation", icon: Users, key: "icp-ideation", href: "/" },
  { title: "Rank a List", icon: List, key: "rank-a-list", href: "/rank-a-list" },
  { title: "Hypotheses", icon: Target, key: "hypotheses", href: "/" },
  { title: "Reports", icon: TrendingUp, key: "reports", href: "/" },
  { title: "Settings", icon: Settings, key: "settings", href: "/" },
];

export const Sidebar: React.FC = () => {
  return (
    <div className="w-64 bg-slate-800 border-r border-slate-700 flex flex-col fixed left-0 top-0 h-screen z-10">
      {/* Logo */}
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center gap-3">
          <img 
            src="/lovable-uploads/6a03a30c-ef41-4650-bf53-41929a228c33.png" 
            alt="AlphaLoop" 
            className="w-8 h-8"
          />
          <span className="text-xl font-bold">AlphaLoop</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <div className="space-y-2">
          {sidebarItems.map((item) => (
            <a
              key={item.key}
              href={item.href}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${
                item.key === 'rank-a-list'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white' 
                  : 'text-slate-300 hover:bg-slate-700 hover:text-white'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.title}</span>
            </a>
          ))}
        </div>
      </nav>
    </div>
  );
}; 